import { createContext } from 'react';
import {
	TFileId,
	IItemForGetShortInfo,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	TCategoryType,
	IUpdateCategory,
	IItemSubCategory,
} from 'types';

export type TVisibleForm = 'mainForm' | 'translations';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';
export interface IInitialFormData {
	IDSelectedCustomer: Nullable<string>;
	IDsSelectedRestaurant: string[];
	nameOfCategory: string;
	categoryType: Nullable<TCategoryType>;
	isRestricted: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	filePath: Nullable<string>;
	translations: IMenuTranslation[];
}

export interface IEditCategoryState {
	needRefetchData: boolean;
	initialFormData: IInitialFormData | null;
	isLoading: boolean;
	visibleForm: TVisibleForm;
	filePath: Nullable<string>;
	preSignedUrl: string | null;
	fileId: TFileId;
	categoryID: string;
	fetchedCustomers: IItemForGetShortInfo[];
	initialIDSelectedCustomer: Nullable<string>;
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	initialIDsSelectedRestaurant: string[];
	IDsSelectedRestaurant: string[];
	nameOfCategory: string;
	categoryType: Nullable<TCategoryType>;
	subcategoriesOfCategory: IItemSubCategory[];
	isRestricted: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IMenuTranslation[];
	dataForSubmit: IUpdateCategory | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editCategoryInitialState: IEditCategoryState = {
	needRefetchData: false,
	initialFormData: null,
	isLoading: true,
	visibleForm: 'mainForm',
	filePath: null,
	preSignedUrl: null,
	fileId: null,
	categoryID: '',
	fetchedCustomers: [],
	initialIDSelectedCustomer: null,
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	initialIDsSelectedRestaurant: [],
	IDsSelectedRestaurant: [],
	nameOfCategory: '',
	categoryType: null,
	subcategoriesOfCategory: [],
	isRestricted: false,
	activationSchedule: '',
	deactivationSchedule: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditCategoryContext extends IEditCategoryState {
	refetchData(value: boolean): void;
	changeLoaderStatus(value: boolean): void;
	changeVisibleForm(value: TVisibleForm): void;
	setFileId(value: TFileId): void;
	deletePhoto(): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	changeNameOfCategory(value: string): void;
	setCategoryType(value: Nullable<TCategoryType>): void;
	toggleIsRestricted(): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setDefaultCustomerLanguage(value: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: IUpdateCategory): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const EditCategoryContext = createContext<IEditCategoryContext>({
	refetchData: () => undefined,
	changeLoaderStatus: () => undefined,
	changeVisibleForm: () => undefined,
	setFileId: () => undefined,
	deletePhoto: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	changeNameOfCategory: () => undefined,
	setCategoryType: () => undefined,
	toggleIsRestricted: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setDefaultCustomerLanguage: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...editCategoryInitialState,
});
